import { Injectable } from '@angular/core';
import { global } from '../../../shared/global';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class EstablishmentRequestService {

    constructor(private http: HttpClient) { }

    fillBoard(data) {
        return this.http.post(global.baseAPIUrl + 'DropDown/fillBoard', data, global.httpOptions);
    }
    fillMedium(data) {
        return this.http.post(global.baseAPIUrl + 'DropDown/fillMedium', data, global.httpOptions);
    }
    fillSection(data) {
        return this.http.post(global.baseAPIUrl + 'DropDown/fillSection', data, global.httpOptions);
    }
    fillStandard(data) {
        return this.http.post(global.baseAPIUrl + 'DropDown/fillStandard', data, global.httpOptions);
    }
    getEstablishmentDetailList(data) {
        return this.http.post(global.baseAPIUrl + 'EstablishmentDetailRequest/getEstablishmentDetailRequestList', data, global.httpOptions);
    }
    saveEstablishmentDetail(data) {
        return this.http.post(global.baseAPIUrl + 'EstablishmentDetailRequest/saveEstablishmentDetailRequest', data, global.httpOptions);
    }
    deleteEstablishmentDetail(data) {
        return this.http.post(global.baseAPIUrl + 'EstablishmentDetailRequest/deleteEstablishmentDetailRequest', data, global.httpOptions);
    }
}